import Store from './Store';
import Subscriptions from '../data/ressources/Subscriptions.json';

const SubscriptionsStore = new Store('subscriptions', Subscriptions);

export { SubscriptionsStore };
